// Import and re-export shared types (moved to avoid circular dependency)
import { TokenSymbolName, TokenWithMarketNetwork, TokenWithMarketNetworkSchema } from "../shared/trading-types";
import { z } from "zod";

export type { TokenSymbolName, TokenWithMarketNetwork };

export const SupportedTokensWithNetworksSchema = z.record(z.string(), z.array(TokenWithMarketNetworkSchema));

export type SupportedTokensWithNetworks = z.infer<typeof SupportedTokensWithNetworksSchema>;

export const TokenMappingItemSchema = z.object({
  /**
   * Exchange token Id
   */
  currencyId: z.string(),
  /**
   * Internal token Id
   */
  code: z.string(),
});
export type TokenMappingItem = z.infer<typeof TokenMappingItemSchema>;

export const TokenMappingArraySchema = z.array(TokenMappingItemSchema);
export type TokenMappingArray = z.infer<typeof TokenMappingArraySchema>;

export const TokenMetadataSchema = z.object({
  code: z.string(),
  name: z.string(),
  // exchangeId -> network -> contract address
  contracts: z.record(z.string(), z.record(z.string(), z.string())).nullable().optional(),
  priceCode: z.string().nullable().optional(),
});
export type TokenMetadata = z.infer<typeof TokenMetadataSchema>;

export const TokenMetadataRecordSchema = z.record(z.string(), TokenMetadataSchema);
export type TokenMetadataRecord = z.infer<typeof TokenMetadataRecordSchema>;
